// extracted by mini-css-extract-plugin
export default {"title":"title__OB-F-","card":"card__23zSu","icon":"icon__2fKF0","item":"item__1-Enl","desc":"desc__JZj9e","layer":"layer__3E2kg","role":"role__36ua5"};